import LoginComponent from "@/components/auth/Login.jsx";
import {buildMeta} from "@/seo/meta";


export const meta = () => {

    return buildMeta({
        title: "Увійдіть до Likengale",
        url: "/auth/login",
        useSuffix: false
    });
}


export default function Login() {
    return (
        <LoginComponent />
    );
}
